export enum RestrictionsQueryParam {
  PAGE = 'restrictionsPage',
  SEARCH = 'restrictionsSearch',
  SIZE = 'restrictionsSize',
}
